import { ISearchStore } from '../index'

export default function(state: ISearchStore): ISearchStore {
  return {
    ...state,
    errMessage: '',
    isLoading: false,
    isReady: true,
  }
}
